module.exports = __webpack_public_path__ + "img/Smaller-Truck-Ad.1c10e181.png";